import React from "react";
import { Link } from "react-router-dom";
// JavaScript plugin that hides or shows a component based on your scroll
import Headroom from "headroom.js";
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
// reactstrap components
import { Image } from 'semantic-ui-react';
import {
  // Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  UncontrolledTooltip,
  NavbarText
} from "reactstrap";
// core components

import { logout } from '../../store/actions/auth';
import DropdownLang1 from "./DropdownLang1";
const hostname = window.location.hostname;

function WhiteNavbar(props) {
  const [bodyClick, setBodyClick] = React.useState(false);
  const [collapseOpen, setCollapseOpen] = React.useState(false);

  const { history, cookies, companyObj = {}, user = {}, webnavArr = [], companies = [], changeCompany } = props;
  const dbLang = cookies.get('dbLang') || 'name';

  React.useEffect(() => {
    let headroom = new Headroom(document.getElementById("navbar-main"));
    // initialise
    headroom.init();
  });


  const data1 = webnavArr.filter(item => item.level === '1' && (item.pageType === '1' || item.pageType === '2' || item.pageType === '3'));

  const profile = (user.isAuthenticated && user.profile && user.profile.toJSON()) || {};
  const [name = '', host] = user.isAuthenticated ? profile.username && profile.username.split('@') : ['', '']
  // console.log(companyObj)
  return (
    <>
      {bodyClick ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setBodyClick(false);
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar style={{ position: 'relative' }} className="fixed-top" expand="lg" id="navbar-main">
        <div className='navBarStyle'>
          {/* <div className="navbar-translate"> */}
          {/* <NavbarText tag={Link} to={'/'}><img src={`${companyObj.img2File.url}`} alt={'...'} style={{ maxHeight: '55px', maxWidth: '55px', marginBottom: '20px' }} /></NavbarText> */}
          <NavbarBrand className='white-navbar-brand' id="navbar-brand" to="/" tag={Link}>
            <span className='yearSpan'>Since1990</span>
          </NavbarBrand>
          <NavbarBrand className='white-navbar-brand' id="navbar-brand" to="/" tag={Link}>
            <Image src={companyObj.img1File.url} alt={'...'} size='medium' />
          </NavbarBrand>
          <UncontrolledTooltip placement="bottom" target="navbar-brand">
            {/* Paper Kit PRO React */}
            {companyObj[dbLang]}
          </UncontrolledTooltip>
          <button
            className="navbar-toggler"
            id="navigation"
            type="button"
            onClick={() => {
              document.documentElement.classList.toggle("nav-open");
              setBodyClick(true);
              setCollapseOpen(true);
            }}
          >
            <span className="navbar-toggler-bar bar1" />
            <span className="navbar-toggler-bar bar2" />
            <span className="navbar-toggler-bar bar3" />
          </button>
          {/* <NavbarText tag='h6' >since 1990</NavbarText> */}
          {/* <button
              className="navbar-toggler"
              id="navigation"
              type="button"
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setBodyClick(true);
                setCollapseOpen(true);
              }}
            >
              <span className="navbar-toggler-bar bar1" />
              <span className="navbar-toggler-bar bar2" />
              <span className="navbar-toggler-bar bar3" />
            </button> */}
          {/* </div> */}
          <Collapse style={{ flexGrow: 0 }} navbar isOpen={collapseOpen}>
            <Nav className="ml-auto" navbar>
              {data1.filter(item => item.isOpen).map(item => ((item.pageType === '2' || item.pageType === '3') && item.objectId !== 'lGC0oFWg6v') ?
                <UncontrolledDropdown nav inNavbar key={item.objectId} >
                  <DropdownToggle color="default" nav caret>{item[dbLang]}</DropdownToggle>
                  <DropdownMenu className="dropdown-danger" right>
                    {webnavArr
                      .filter(item2 => item2.isOpen && item2.level === '2' && item2.nav1Id === item.objectId)
                      .map(element =>
                        <DropdownItem
                          key={element.objectId}
                          id={"b" + element.objectId}
                          to={`${item.pageType === '3' ? '/#' : '/page/'}${element.path2 || element.objectId}`}
                          tag={Link}
                        >
                          {element[dbLang]}
                        </DropdownItem>
                      )}
                  </DropdownMenu>
                </UncontrolledDropdown> :
                <NavItem key={item.objectId} >
                  <NavLink id={"a" + item.objectId} to={item.path1 ? `/page/${item.path1 || item.objectId}` : '/'} tag={Link}>{item[dbLang]}</NavLink>
                </NavItem>
              )}
              {companyObj.isMultiLang ? <DropdownLang1 {...props} /> : null}
              {user.isAuthenticated ?
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle caret color="default" nav>
                    <i className="fa fa-user-o" />
                  </DropdownToggle>
                  <DropdownMenu aria-labelledby="navbarDropdownMenuLink" className="dropdown-danger" right>
                    <DropdownItem header>{name}</DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem to="/profile" tag={Link}>個人資料</DropdownItem>
                    <DropdownItem to="/webDesign" tag={Link}>網站設計</DropdownItem>
                    {companyObj.isMultiLang ? <DropdownItem to="/localeManage" tag={Link}>多國語系</DropdownItem> : null}
                    <DropdownItem href="/admin/dashboard" >後台管理</DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem
                      // href="/logout"
                      href="#"
                      onClick={logout}
                    >登出</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown> : null}
              {hostname === 'localhost' ?
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle caret color="default" nav>
                    <i className="fa fa-desktop" />
                  </DropdownToggle>
                  <DropdownMenu aria-labelledby="navbarDropdownMenuLink" className="dropdown-danger" right>
                    {companies.length && companies.map(({ name, objectId }) => (<DropdownItem key={"ab" + objectId}
                      onClick={e => {
                        e.preventDefault()
                        changeCompany(objectId)
                        history.push('/')
                      }}
                    >{name}</DropdownItem>))}
                  </DropdownMenu>
                </UncontrolledDropdown> : null}
            </Nav>
          </Collapse>
        </div>
      </Navbar>
    </>
  );
}

// export default WhiteNavbar;
const mapStateToProps = state => ({
  user: state.user
});
// export default withCookies(ColorNavbar);
export default connect(mapStateToProps, { logout })(withCookies(WhiteNavbar));
